<template>
	<div class="facility-info-card" :id="id">
		<h2 v-if="title" class="facility-info-card__title">
			{{ title }}
		</h2>
		<div class="facility-info-card__header">
			<SvgIcon icon="pin" class="facility-info-card__icon" color="white" />
			<div class="facility-info-card__venue">
				{{ facilityName }}
			</div>
		</div>
		<a
			v-if="facilityAddress && googleMapsUrl"
			:href="googleMapsUrl.url"
			target="_blank"
			class="facility-info-card__address"
		>
			{{ facilityAddress }}
		</a>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const facilityName = computed(() => props.fields?.facilityName?.value);
const facilityAddress = computed(() => props.fields?.facilityAddress?.value);
const googleMapsUrl = computed(() => props.fields?.googleMapsUrl?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.facility-info-card {
	display: flex;
	padding: var(--spacing-3, 24px);
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	align-self: stretch;
	border-radius: 16px;
	background: var(--color-grey, #282828);
	color: var(--color-white, #fff);
	margin: 16px;

	.facility-info-card__title {
		color: var(--color-white, #fff);
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-lg, 20px);
		font-weight: 900;
		line-height: 110%;
		text-transform: uppercase;
	}

	.facility-info-card__header {
		display: flex;
		align-items: center;
	}

	.facility-info-card__icon {
		margin-right: 10px;
	}

	.facility-info-card__icon.svg-icon {
		width: 32px;
		height: 32px;
	}

	.facility-info-card__venue {
		color: var(--color-white, #fff);
		font-size: var(--text-sm, 14px);
		font-weight: 700;
		line-height: 150%;
	}

	.facility-info-card__address {
		color: #e9e9e9;
		font-size: var(--text-sm, 14px);
		font-weight: 400;
		line-height: 150%;
	}
}
</style>
